
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent } from 'vue';
import { getStartupLocale, setLocale, useI18n, setSupportedLocales } from '@/i18n';

import { LABEL_COOKIE_REQUIRED, LABEL_SERVER_ERROR, LABEL_SERVER_ERROR_TRY_LATER } from '@/libs/i18nLabels';
import LanguageSelector from './components/lang-select.vue';
import isCookieEnabled from './libs/cookieCheck';
import { addQueryStringParams } from './libs/urlUtils';
import regInfo from './libs/querystringInfo';
import registrationState, { RegistrationServerInfo, PANEL } from './libs/registrationState';
import Registration from './views/Registration.vue';

interface AppData {
  serverInfo: RegistrationServerInfo | null;
  cookieEnabled: boolean;
  serverError: boolean;
  isReady: boolean;
}

export default defineComponent({
  components: { LanguageSelector, Registration },
  name: 'App',

  data(): AppData {
    return {
      isReady: false,
      serverError: false,
      serverInfo: null,
      cookieEnabled: isCookieEnabled(),
    };
  },

  setup() {
    return {
      regInfo,
      userAgent: navigator.userAgent,
      LABEL_COOKIE_REQUIRED,
      LABEL_SERVER_ERROR,
      LABEL_SERVER_ERROR_TRY_LATER,
      // eslint-disable-next-line no-underscore-dangle
      lgUrls: (window as any)._lgUrls,
    };
  },

  async mounted() {
    const i18n = useI18n();
    this.isReady = false;

    try {
      this.serverInfo = await registrationState.fetchServerInfo(regInfo);
    } catch (err) {
      this.serverError = true;
      return;
    }

    // set locale after setting supported locales
    if (this.serverInfo.ui.supportedLanguages) {
      const supportedLanguages = this.serverInfo.ui.supportedLanguages as string;
      setSupportedLocales(supportedLanguages.split(','));
    }

    const locale = getStartupLocale();
    await setLocale(i18n, locale);

    this.isReady = true;
  },

  methods: {},

  computed: {
    logoUrl() {
      if (regInfo.isMailfence) {
        // eslint-disable-next-line global-require
        return require('./assets/mailfence.svg');
      }

      if (!this.serverInfo || !this.serverInfo.ui) {
        return null;
      }

      return this.serverInfo.ui.logoUrl;
    },

    serviceName() {
      return (this.serverInfo && this.serverInfo.ui && this.serverInfo.ui.ServiceName) || '';
    },

    displayLgSelector() {
      return this.isReady && registrationState.state.panelToDisplay === PANEL.HOME;
    },

    discoverUrl() {
      if (!this.serverInfo || !this.serverInfo.ui) {
        return null;
      }

      const url = addQueryStringParams('/', { src: (regInfo.source || '').trim(), forcelg: this.$i18n.locale });
      return url;
    },
  },
});
